import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { PagedCollectionParams } from '../../models/paged-collection-params';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { customPlacePagedCollectionSchema } from './schemas/custom-places-paged-collection.schema';

export function getPlaceSets(params?: PagedCollectionParams) {
  return fromFetch(
    new Request(
      `${fleetEnvironment.placeSetsUrl}?${params ? params.urlParams : ''}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
      }
    )
  ).pipe(selectData(customPlacePagedCollectionSchema));
}
